import React, {useMemo} from 'react'
import ReactApexChart from 'react-apexcharts'
import OfferFollowNoDataChart from './OfferFollowNoDataChart';
import {Divider, IconButton, Typography} from '@mui/material';
import {TrendingDown, TrendingUp} from '@mui/icons-material';

export default function OfferFollowChart({chartShown, dataChart}) {
    const colorBluePrimary = 'var(--btn-color-primary-blue)';
    const colorOrange = 'var(--btn-color-orange)';
    const colorGray = 'var(--btn-color-gray-deselected)';
    /**
     *
     */
    const datesArray = dataChart.data.map((entry) => entry.FollowDate)
    /**
     *
     */
    const dailyActiveAdsArray = dataChart.data.map((entry) => entry.DailyActiveAds)
    /**
     * Estilo para los botones de accion.
     * @type {{backgroundColor: string, color: string, '&:hover': {background: string}}}
     */
    const styleBtnIcon = {
        backgroundColor: 'red', color: 'white'
    };
    /**
     *
     * @type {{plotOptions: {bar: {horizontal: boolean, endingShape: string, columnWidth: string}}, dataLabels: {enabled: boolean}, xaxis: {categories: *}, tooltip: {y: {formatter: function(*): string}}, fill: {opacity: number}, chart: {type: string, height: number}, stroke: {show: boolean, width: number, colors: [string]}, colors: [string]|[string]}}
     */
    const chartOptions = useMemo(() => ({
        chart: {
            type: 'bar',
            height: 200,
        },
        plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: '55%',
                endingShape: 'rounded',
            },
        },
        dataLabels: {
            enabled: false,
        },
        stroke: {
            show: true,
            width: 2,
            colors: ['transparent'],
        },
        xaxis: {
            categories: datesArray,
        },
        fill: {
            opacity: 1,
        },
        tooltip: {
            y: {
                formatter: function (val) {
                    return val + ' ads'
                },
            },
        },
        colors: chartShown === 'page' ? [colorBluePrimary] : [colorOrange],
    }), [chartShown, datesArray])

    const footer = (title, description, QuantityVariation, firstColor) => {
        let colorTitleBackground = chartShown === 'page' ? colorBluePrimary : colorOrange;
        return (
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                width: '50%',
                paddingLeft: '16px',
                paddingRight: '16px',
            }}>
                <Typography
                    variant='h5'
                    sx={{
                        width: '100%',
                        backgroundColor: firstColor === colorGray ? firstColor : colorTitleBackground,
                        color: firstColor === colorBluePrimary ? 'white' : 'black',
                        fontWeight: 'bold',
                        alignSelf: 'center',
                        paddingTop: 1,
                        paddingBottom: 1,
                    }}>{title}</Typography>
                <Typography
                    fontSize={'large'}
                    fontWeight={'bold'}
                    sx={{
                        marginTop: '8px',
                        textAlign: 'left',
                        color: 'black'
                    }}>{description}</Typography>
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    marginTop: '4px',
                    gap: 1
                }}>
                    <Typography
                        fontSize={'larger'}
                        sx={{
                            textAlign: 'left'
                        }}>{QuantityVariation}&ensp;anuncios&ensp;</Typography>
                    {
                        dataChart.info.QuantityAdsDailyVariation > 0 ? (
                            <IconButton>
                                <TrendingUp/>
                            </IconButton>
                        ) : (
                            <IconButton size={'small'} sx={styleBtnIcon}>
                                <TrendingDown fontSize='inherit'/>
                            </IconButton>
                        )
                    }
                </div>
            </div>
        )
    }

    return (
        <>
            {
                dataChart.data.length === 0 ? (
                    <OfferFollowNoDataChart/>
                ) : (
                    <>
                        <ReactApexChart
                            options={chartOptions}
                            series={[
                                {
                                    name: 'Cantidad Diaria de Anuncios Activos',
                                    data: dailyActiveAdsArray,
                                },
                            ]}
                            type='bar'
                            height={200}
                        />
                        <Divider/>
                        <div style={{display: 'flex', marginTop: '16px'}}>
                            {footer('Hoy', 'Variación diaria',
                                dataChart.info.QuantityAdsDailyVariation,
                                colorBluePrimary)}
                            {footer('Ayer', 'Variación samanal',
                                dataChart.info.QuantityAdsDailyVariation, colorGray)}
                        </div>
                    </>
                )
            }
        </>
    );
}
